import 'babel-polyfill/dist/polyfill.js'
import React from 'react'
import ReactDOM from 'react-dom'
import 'font-awesome/css/font-awesome.min.css'
import { Router, Route } from 'react-router-dom'
import { Layout } from './layout'
import { store } from './store/app'
import { Provider } from 'react-redux'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import { history } from 'helpers/history'
import i18n from './i18n'
import { initPrintListener } from "helpers/print"

const domElement = document.getElementById('root')

const preventPinchZoomOnDocument = event => {
    if(event.touches.length !== 1)
    {
        event.preventDefault()
    }
}

domElement.addEventListener('touchmove', preventPinchZoomOnDocument)

const defineViewportHeight = () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

defineViewportHeight()
window.addEventListener('resize', defineViewportHeight);

ReactDOM.render(
    <MuiThemeProvider>
      <Provider store={ store }>
        <Router history={history}>
          <Route path="/" component={ Layout } />
        </Router>
      </Provider>
    </MuiThemeProvider>,
  domElement
)

initPrintListener()
